<template>
  <div :class="{'readonly': readonly}">
    <div class="btn-count btn-minus" @click="minus"></div>
    <input type="number"
           class="hz-input-default hz-input-lg text-center"
           min="1"
           max="365"
           placeholder="예) 1"
           v-model.number="count"
           required
           :readonly="readonly"
    >
    <div class="btn-count btn-plus" @click="plus"></div>
  </div>
</template>

<script>
  export default {
    name: 'input-count',
    props: {
      readonly: {
        type: Boolean,
        default () {
          return false
        }
      },
      max: {
        type: Number,
        default () {
          return 999
        }
      },
      min: {
        type: Number,
        default () {
          return 0
        }
      },
      value: {
        type: Number,
        default () {
          return 0
        }
      }
    },
    data () {
      return {
        count: 0
      }
    },
    watch: {
      value (val) {
        this.count = val
      },
      count (val) {
        if (val === '') {
          this.count = 0
          return
        }

        if (this.max < val) {
          this.count = this.max
          return
        }

        this.$emit('update', val)
      }
    },
    methods: {
      plus () {
        if (!this.readonly && this.count < this.max) {
          this.count += 1
        }
      },
      minus () {
        if (!this.readonly && this.min < this.count) {
          this.count -= 1
        }
      }
    },
    created () {
      this.count = this.value
    }
  }
</script>

<style lang="scss" scoped>
  .hz-input-default {
    float: left;
    width: calc(100% - 96px);
    border-width: 1px 0 1px;
    border-color: $border-color;
    border-radius: 0;
    box-shadow: 0 1px 1px 0 rgba(173, 181, 189, 0.3);
  }

  .btn-count {
    float: left;
    width: 48px;
    height: 48px;
    box-shadow: 0 1px 1px 0 rgba(173, 181, 189, 0.3);
    border: solid 1px $border-color;
    background-color: $light-grey;
    cursor: pointer;

    &:hover {
      background-color: $hzc-gray-01;
    }

    .readonly & {
      background-color: $light-grey;
      cursor: not-allowed;
    }
  }

  .btn-minus {
    background: center no-repeat url('~@/assets/svg/ic-minus-black.svg');
    background-size: 20px 20px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .btn-plus {
    background: center no-repeat url('~@/assets/svg/ic-plus-black.svg');
    background-size: 20px 20px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/InputCount.vue